import { render, staticRenderFns } from "./PrintProductItem.vue?vue&type=template&id=845cb644&"
import script from "./PrintProductItem.vue?vue&type=script&lang=js&"
export * from "./PrintProductItem.vue?vue&type=script&lang=js&"
import style0 from "./PrintProductItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports